/* Sticky bar for the UTC offer box (snippets/lp-uo-sticky.liquid).
   p6v2 (default): two subscription rows; "Start today" clicks the offer box's own per-card Buy Now
   button for the chosen plan, so the cart, gifts, tracking and checkout redirect stay the box's.
   scroll (?uos=scroll, or when prices are unavailable): trust line + a button that scrolls to the box. */
(function () {
  'use strict';
  function fire(name, data) {
    if (typeof window.fireEvent === 'function') { try { window.fireEvent(name, data || {}); } catch (e) {} }
  }
  function init() {
    var bar = document.getElementById('uo-sticky');
    if (!bar) return;
    var box = document.getElementById(bar.getAttribute('data-box-id') || 'uo-offer');
    var forceScroll = /[?&]uos=scroll\b/.test(window.location.search);
    var card = bar.querySelector('.uos-card');
    var scrollWrap = bar.querySelector('[data-uos-scroll]');
    var style = (card && !forceScroll) ? 'p6v2' : 'scroll';
    bar.setAttribute('data-uos-style', style);
    if (style === 'scroll') {
      if (card) card.hidden = true;
      if (scrollWrap) scrollWrap.hidden = false;
    }
    bar.hidden = false;

    function scrollToBox() {
      if (!box) return;
      var reduce = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () {
        var r = box.querySelector('[role="radio"][aria-checked="true"]') || box.querySelector('[role="radio"]');
        if (r) { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }
      }, 500);
    }

    /* visibility: after 600px of scroll, hidden while the box itself is on screen (unless the bar is open) */
    var inBox = false, past = false, open = false;
    function apply() { bar.classList.toggle('is-on', past && (!inBox || open)); }
    function onScroll() {
      var was = past;
      past = (window.pageYOffset || document.documentElement.scrollTop || 0) > 600;
      if (was !== past) apply();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (box && typeof window.IntersectionObserver === 'function') {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inBox = e.isIntersecting; });
        apply();
      }).observe(box);
    }
    apply();

    if (style === 'scroll') {
      var btn = bar.querySelector('[data-uos-btn]');
      var setLabel = function () {
        if (!btn) return;
        var pr = box && box.getAttribute('data-uo-cta-price');
        btn.textContent = pr ? 'Start My Plan · ' + pr : 'Start My Plan';
      };
      setLabel();
      if (box && typeof window.MutationObserver === 'function') {
        new MutationObserver(setLabel).observe(box, { attributes: true, attributeFilter: ['data-uo-cta-price'] });
      }
      if (btn) btn.addEventListener('click', scrollToBox);
      return;
    }

    var trigger = bar.querySelector('[data-uos-trigger]');
    var panel = bar.querySelector('[data-uos-panel]');
    var atc = bar.querySelector('[data-uos-atc]');
    var atcMain = bar.querySelector('[data-uos-atc-main]');
    var status = bar.querySelector('[data-uos-status]');
    var opts = Array.prototype.slice.call(bar.querySelectorAll('.uos-opt'));
    var plan = '3';

    function setOpen(v) {
      open = v;
      bar.classList.toggle('is-open', v);
      if (panel) panel.hidden = !v;
      if (trigger) trigger.setAttribute('aria-expanded', v ? 'true' : 'false');
      apply();
    }
    if (trigger) trigger.addEventListener('click', function () {
      setOpen(true);
      fire('uos_open', { style: 'p6v2' });
    });
    document.addEventListener('click', function (e) {
      if (open && !bar.contains(e.target)) setOpen(false);
    });

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        plan = o.getAttribute('data-plan');
        opts.forEach(function (x) { x.classList.toggle('is-sel', x === o); });
        var inp = o.querySelector('input');
        if (inp) inp.checked = true;
        if (atcMain) atcMain.textContent = o.getAttribute('data-main') || atcMain.textContent;
      });
    });

    if (atc) atc.addEventListener('click', function () {
      fire('uos_add', { style: 'p6v2', plan: plan });
      var sel = bar.getAttribute(plan === '3' ? 'data-btn3' : 'data-btn1') || ('button[data-act="addk"][data-plan="' + plan + '"]');
      var target = box && box.querySelector(sel);
      if (target && !target.disabled) {
        atc.disabled = true;
        if (status) status.textContent = 'Taking you to checkout...';
        /* Stamp the cart so orders started from this sticky are countable
           (satc_variant/satc_arm match lp-r5m-sticky; buy_surface is shared
           with the LP offer cards). The box doesn't clear the cart, so the
           attributes survive its add. Capped at 700ms. */
        var fdS = new FormData();
        fdS.append('attributes[satc_variant]', 'uos-' + style);
        fdS.append('attributes[satc_arm]', 'uo-sticky');
        fdS.append('attributes[buy_surface]', 'uo-sticky');
        var stampReq = fetch('/cart/update.js', { method: 'POST', body: fdS, keepalive: true, headers: { 'Accept': 'application/json' } }).catch(function () {});
        Promise.race([stampReq, new Promise(function (r) { setTimeout(r, 700); })]).then(function () { target.click(); });
        /* if the box reports an error it re-enables its own button; re-enable ours after a beat too */
        setTimeout(function () { atc.disabled = false; if (status && status.textContent === 'Taking you to checkout...') status.textContent = ''; }, 8000);
      } else {
        setOpen(false);
        scrollToBox();
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
